import { PipeTransform, Pipe } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'sanitizeUrl',
    standalone: false
})
export class SanitizeUrlPipe implements PipeTransform {
  constructor(private _sanitizer: DomSanitizer) {}

  transform(v): SafeHtml {
    return this._sanitizer.bypassSecurityTrustResourceUrl(v);
  }
}
